import { useIsRestoring } from "@tanstack/react-query";
import { useCallback, useRef, useEffect } from "react";

export const useQueryCacheRestoring = () => {
  const isRestoring = useIsRestoring();

  const resolverRef = useRef<((value: boolean) => void)[]>([]);

  const whenCacheRestored = useCallback(async () => {
    return await new Promise<boolean>((resolve) => {
      if (!isRestoring) {
        resolve(true);
        return;
      }
      resolverRef.current.push(resolve);
    });
  }, [isRestoring]);

  useEffect(() => {
    const resolveAll = (value: boolean) => {
      const resolvers = resolverRef.current;
      resolverRef.current = [];
      resolvers.forEach((resolver) => resolver(value));
    };

    if (!isRestoring) {
      resolveAll(true);
    }

    return () => {
      resolveAll(false);
    };
  }, [isRestoring]);

  return { isRestoring, whenCacheRestored } as const;
};
